// WOOD Gentlemen - Custom Sections JavaScript Integration
// Handles Hero Slider, Product Carousel, Swatches and Theme Editor lifecycle events.
// Selectors updated for prefix: wood-

(function() {
  
  // 1. Hero Slider Initialization
  function initHeroSlider(section) {
    const sliderContainer = section.querySelector('.wood-hero-slider');
    if (!sliderContainer) return;
    
    // Clean up any existing interval if running
    if (sliderContainer.slideInterval) {
      clearInterval(sliderContainer.slideInterval);
    }
    
    const slides = section.querySelectorAll('.wood-hero-slide');
    const dots = section.querySelectorAll('.wood-dot');
    const prevBtn = section.querySelector('.wood-slider-arrow.prev');
    const nextBtn = section.querySelector('.wood-slider-arrow.next');
    
    if (slides.length === 0) return;
    
    let currentSlide = 0;
    const sectionContainer = section.querySelector('.wood-hero-slider-section');
    const speed = parseInt((sectionContainer && sectionContainer.dataset.autoplay) || '5') * 1000;
    
    function showSlide(index) {
      // Deactivate current slide/dot
      slides[currentSlide].classList.remove('active');
      if (dots.length > currentSlide) {
        dots[currentSlide].classList.remove('active');
      }
      
      // Calculate new slide index
      currentSlide = (index + slides.length) % slides.length;
      
      // Activate new slide/dot
      slides[currentSlide].classList.add('active');
      if (dots.length > currentSlide) {
        dots[currentSlide].classList.add('active');
      }
    }
    
    function nextSlide() {
      showSlide(currentSlide + 1);
    }
    
    function startAutoplay() {
      if (slides.length > 1) {
        sliderContainer.slideInterval = setInterval(nextSlide, speed);
      }
    }
    
    // Bind Arrow Clicks
    if (nextBtn) {
      nextBtn.onclick = () => {
        showSlide(currentSlide + 1);
        if (sliderContainer.slideInterval) {
          clearInterval(sliderContainer.slideInterval);
          startAutoplay();
        }
      };
    }
    
    if (prevBtn) {
      prevBtn.onclick = () => {
        showSlide(currentSlide - 1);
        if (sliderContainer.slideInterval) {
          clearInterval(sliderContainer.slideInterval);
          startAutoplay();
        }
      };
    }
    
    // Bind Dot Clicks
    dots.forEach((dot, idx) => {
      dot.onclick = () => {
        showSlide(idx);
        if (sliderContainer.slideInterval) {
          clearInterval(sliderContainer.slideInterval);
          startAutoplay();
        }
      };
    });
    
    // Bind Swipe Gestures (Touch)
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let isSwiping = false;
    let hasSwiped = false;

    sliderContainer.addEventListener('touchstart', (e) => {
      if (!e.touches || e.touches.length === 0) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchEndX = touchStartX;
      touchEndY = touchStartY;
      isSwiping = true;
      hasSwiped = false;
      if (sliderContainer.slideInterval) {
        clearInterval(sliderContainer.slideInterval);
      }
    }, { passive: true });

    sliderContainer.addEventListener('touchmove', (e) => {
      if (!isSwiping || !e.touches || e.touches.length === 0) return;
      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;
      if (Math.abs(touchEndX - touchStartX) > 10) {
        hasSwiped = true;
      }
    }, { passive: true });

    sliderContainer.addEventListener('touchend', () => {
      if (!isSwiping) return;
      isSwiping = false;
      const diffX = touchEndX - touchStartX;
      const diffY = touchEndY - touchStartY;

      // Minimum swipe threshold 40px, ensure horizontal gesture is dominant
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
        if (diffX < 0) {
          // Swipe left -> next slide
          showSlide(currentSlide + 1);
        } else {
          // Swipe right -> prev slide
          showSlide(currentSlide - 1);
        }
      }

      if (sliderContainer.slideInterval) {
        clearInterval(sliderContainer.slideInterval);
      }
      startAutoplay();
    });

    // Prevent accidental banner link click during swiping
    sliderContainer.addEventListener('click', (e) => {
      if (hasSwiped) {
        e.preventDefault();
        e.stopPropagation();
        hasSwiped = false;
      }
    }, true);

    // Start initial autoplay
    startAutoplay();
  }
  
  // 2. New Arrivals Horizontal Scroll
  function initNewArrivalsScroll(section) {
    const wrapper = section.querySelector('.wood-product-slider-wrapper');
    const nextScrollBtn = section.querySelector('.wood-slider-controls .wood-control-btn.next');
    const prevScrollBtn = section.querySelector('.wood-slider-controls .wood-control-btn.prev');
    
    if (wrapper && nextScrollBtn && prevScrollBtn) {
      nextScrollBtn.onclick = () => {
        const card = wrapper.querySelector('.wood-product-card') || wrapper.querySelector('.product-block');
        const scrollAmount = card ? card.offsetWidth + 20 : 320;
        wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      };
      
      prevScrollBtn.onclick = () => {
        const card = wrapper.querySelector('.wood-product-card') || wrapper.querySelector('.product-block');
        const scrollAmount = card ? card.offsetWidth + 20 : 320;
        wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      };
    }
  }
  
  // 3. Color Swatch Click Handler
  function initSwatches(section) {
    const swatchContainers = section.querySelectorAll('.wood-color-swatches');
    swatchContainers.forEach(container => {
      const swatches = container.querySelectorAll('.wood-swatch');
      // Find the card image element in the parent product card
      const card = container.closest('.wood-product-card') || container.closest('.product-block');
      const imgElement = card ? (card.querySelector('.wood-product-img') || card.querySelector('.product-block__image img') || card.querySelector('.theme-img img') || card.querySelector('.rimage-wrapper img') || card.querySelector('img')) : null;
      
      swatches.forEach(swatch => {
        swatch.onclick = (e) => {
          e.preventDefault(); // Prevent link click if nested in <a>
          e.stopPropagation();
          swatches.forEach(s => s.classList.remove('active'));
          swatch.classList.add('active');
          
          // Update the card image dynamically if a variant image is provided
          const variantImage = swatch.dataset.variantImage;
          if (variantImage && imgElement) {
            imgElement.src = variantImage;
            imgElement.srcset = variantImage;
          }
        };
      });
    });
  }
  
  // Reusable Dispatcher
  function initSection(section) {
    if (section.classList.contains('section-custom-hero-slider')) {
      initHeroSlider(section);
    }
    if (section.classList.contains('section-custom-new-arrivals')) {
      initNewArrivalsScroll(section);
    }
    if (section.querySelector('.wood-color-swatches')) {
      initSwatches(section);
    }
  }
  
  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.shopify-section').forEach(section => {
      initSection(section);
    });

    // Add global click handler for BOGO tags to open the terms and conditions modal
    document.addEventListener('click', (e) => {
      const badge = e.target.closest('.wood-product-tag-badge--clickable');
      if (badge) {
        e.preventDefault();
        e.stopPropagation();
        const bogoModal = document.getElementById('bogo-modal');
        if (bogoModal) {
          bogoModal.open(badge);
        }
      }
    });
  });
  
  // Listen for Shopify Section Events (Theme Editor Customizer support)
  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
  });
  
  document.addEventListener('shopify:section:unload', (event) => {
    // Clean up slideInterval if unloading hero slider
    const sliderContainer = event.target.querySelector('.wood-hero-slider');
    if (sliderContainer && sliderContainer.slideInterval) {
      clearInterval(sliderContainer.slideInterval);
    }
  });
  
})();
